module.exports = __webpack_public_path__ + "img/thumbPadrao.97f752a5.jpg";